import React from 'react';

/** Admin shows the Firmitas by Fides lockup here; the investor portal deliberately does not. */
const HeaderBrandLockup: React.FC = () => null;

export default HeaderBrandLockup;
